/* eslint-disable react/jsx-no-useless-fragment */
import type React from 'react';
import { Fragment } from 'react';
// biome-ignore lint/suspicious/noShadowRestrictedNames: Error is the shared error-display component
import Error from '../common/Error/Error';

interface Props {
    isLoading: boolean;
    error?:
        | {
              message: string;
              response: {
                  message: string;
                  status: number;
              };
          }
        | undefined;
    loadingFallback: React.ReactNode;
    children?: React.ReactNode | (() => React.JSX.Element | React.JSX.Element[] | null | undefined);
}

const Loading = ({ isLoading, loadingFallback, error, children }: Props) => {
    if (isLoading && loadingFallback && !error) return <Fragment>{loadingFallback}</Fragment>;

    if (error && error.response.status !== 401)
        return <Error label="Sorry, you do not have access to view this resource." />;

    return <Fragment>{typeof children === 'function' ? children() : children}</Fragment>;
};

export default Loading;
